import type { WebApplicationState } from './types';
import { DEFAULT_WEB_APP_STATE } from './types';

export interface WebApplicationInput {
  kind?: string;
  version?: string;
  state?: Partial<WebApplicationState>;
  application?: Partial<WebApplicationState['application']>;
  details?: Partial<WebApplicationState['details']>;
  deployment?: Partial<WebApplicationState['deployment']>;
  service?: Partial<WebApplicationState['service']>;
}

function envVarObjectToLines(value: unknown) {
  if (!value || typeof value !== 'object' || Array.isArray(value)) {
    return typeof value === 'string' ? value : '';
  }

  return Object.entries(value as Record<string, string>)
    .map(([key, envValue]) => `${key}=${envValue}`)
    .join('\n');
}

function unwrapWebApplicationState(raw: WebApplicationInput | null): Partial<WebApplicationState> {
  if (!raw) {
    return {};
  }

  if (raw.state?.application) {
    return raw.state;
  }

  if (raw.application) {
    return raw as Partial<WebApplicationState>;
  }

  return {};
}

export function mapJsonToWebApplicationState(raw: WebApplicationInput | null): WebApplicationState {
  const restored = unwrapWebApplicationState(raw);

  return {
    application: {
      ...DEFAULT_WEB_APP_STATE.application,
      ...restored.application,
    },
    details: {
      ...DEFAULT_WEB_APP_STATE.details,
      ...restored.details,
    },
    deployment: {
      ...DEFAULT_WEB_APP_STATE.deployment,
      ...restored.deployment,
      environment_variables:
        restored.deployment?.environment_variables === undefined
          ? DEFAULT_WEB_APP_STATE.deployment.environment_variables
          : envVarObjectToLines(restored.deployment.environment_variables),
    },
    service: {
      ...DEFAULT_WEB_APP_STATE.service,
      ...restored.service,
    },
  };
}
